import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MessageCircle } from 'lucide-react';

const API = '/api';

const WhatsAppButton = () => {
  const [whatsappNumber, setWhatsappNumber] = useState('01636849710');

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      if (response.data.whatsapp_number) {
        setWhatsappNumber(response.data.whatsapp_number);
      }
    } catch (error) {
      console.error('Failed to fetch settings', error);
    }
  };

  const handleClick = () => {
    const formattedNumber = whatsappNumber.startsWith('+') ? whatsappNumber : `+49${whatsappNumber}`;
    const message = encodeURIComponent('Hallo! Ich möchte einen Termin bei Salon Galo buchen.');
    window.open(`https://wa.me/${formattedNumber.replace(/[^0-9+]/g, '')}?text=${message}`, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-8 right-8 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl flex items-center justify-center transition-all hover:scale-110 group"
      aria-label="WhatsApp kontaktieren"
      data-testid="whatsapp-button"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute right-16 bg-green-500 text-white px-3 py-1 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity">
        WhatsApp Chat
      </span>
    </button>
  );
};

export default WhatsAppButton;
